import classNames from 'classnames/bind';
import styles from './BookInfo.module.css';

import { EBOOK_INFO_LIST } from '../../../../constants';

import Item from '../Item';
import InputRow from '../InputRow';
import { isMobile } from '../../../../utils/util';

interface BookInfo {
  id: string;
}

export default function BookInfo({ id }: BookInfo) {
  const cx = classNames.bind(styles);

  return (
    <Item id={id} innerClass="s_min">
      {EBOOK_INFO_LIST.map(([title, key]) =>
        isMobile && key === 'orgCoverYn' ? null : (
          <InputRow key={key} name={key} title={title} />
        )
      )}
    </Item>
  );
}
